import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled, { css } from 'styled-components';

import { Spinner } from '@treams/treams-ui';

import CheckmarkIcon from 'packages/kakapo-ui-kit/assets/icons/CheckmarkIcon';
import CloseIcon from 'packages/kakapo-ui-kit/assets/icons/CloseIcon';
import PlusIconSmall from 'packages/kakapo-ui-kit/assets/icons/PlusIconSmall';

const OptInButtonStyleWhite = css`
	color: ${(props) => props.theme.colors.slateBlue};
	background-color: ${(props) => props.theme.colors.white};

	svg g g {
		fill: ${(props) => props.theme.colors.slateBlue};
	}
`;

const OptInButtonStylePrimary = css`
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};

	svg g g {
		fill: ${(props) => props.theme.colors.white};
	}
`;

const OptInButton = styled.button<{ joined: boolean }>`
	display: block;
	font-size: 13px;
	border: 0;
	outline: 0;
	padding: 7px 15px;
	border-radius: 6px;
	font-weight: 700;
	display: flex;
	align-items: center;
	transition: 150ms background-color ease-out;
	white-space: nowrap;

	:disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	svg {
		height: 12px;
		display: inline-block;
	}

	${OptInButtonStyleWhite}

	:hover {
		${OptInButtonStylePrimary}
	}

	${(props) =>
		props.joined &&
		`
		${OptInButtonStylePrimary}

		:hover {
			${OptInButtonStyleWhite}
		}
	`}
`;

const OptInButtonIcon = styled(Box)`
	width: 16px;
	height: 16px;
	margin-left: -4px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const OptIn = ({
	joined,
	loading,
	disabled,
	onClick,
}: {
	joined: boolean;
	loading?: boolean;
	disabled?: boolean;
	onClick: () => void;
}) => {
	const [isHovered, setIsHovered] = useState<boolean>(false);
	const { t } = useTranslation();

	return (
		<OptInButton
			type="button"
			disabled={disabled}
			joined={joined}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onClick={onClick}
		>
			{loading && <Spinner />}
			{!loading && (
				<>
					{joined ? (
						<>
							<OptInButtonIcon mr={2}>
								{isHovered ? <CloseIcon /> : <CheckmarkIcon />}
							</OptInButtonIcon>
							{isHovered
								? t('learning.event.rsvp.remove.button.title')
								: t('learning.event.rsvp.joined.button.title')}
						</>
					) : (
						<>
							<OptInButtonIcon mr={2}>
								<PlusIconSmall />
							</OptInButtonIcon>
							{t('learning.event.rsvp.join.button.title')}
						</>
					)}
				</>
			)}
		</OptInButton>
	);
};

export default OptIn;
